import React from 'react';
import { Grid } from 'semantic-ui-react';
import CopyToClipBoardv2 from 'app/components/CopyToClipboard/index';
import constants from 'app/constants/global-constants';
var DatabaseInformation = function (_a) {
    var data = _a.data;
    var onCopied = function (key) {
        window.neo4jSandbox.tracking.event('SANDBOX_COPY_TO_CLIPBOARD', { key: key });
    };
    return (React.createElement(Grid, { className: "font-small" },
        React.createElement(Grid.Column, { width: 8 },
            React.createElement(Grid, null,
                React.createElement(Grid.Column, { width: 16, className: "mb2 py0" },
                    React.createElement("span", { className: "color-charcoal", style: { width: 80, display: 'inline-block' } }, "Username:"),
                    React.createElement(CopyToClipBoardv2, { onCopy: function () { return onCopied('username'); }, copyText: data.username || 'neo4j' }, data.username || 'neo4j')),
                React.createElement(Grid.Column, { width: 16, className: "mb2 py0" },
                    React.createElement("span", { className: "color-charcoal", style: { width: 80, display: 'inline-block' } }, "Password:"),
                    React.createElement(CopyToClipBoardv2, { onCopy: function () { return onCopied('password'); }, copyText: data.password || 'letmein' }, data.password || 'letmein')))),
        React.createElement(Grid.Column, { width: 8 },
            React.createElement(Grid, null,
                React.createElement(Grid.Column, { width: 16, className: "mb2 py0" },
                    React.createElement("span", { className: "color-charcoal", style: { width: 80, display: 'inline-block' } }, "IP Address:"),
                    React.createElement(CopyToClipBoardv2, { onCopy: function () { return onCopied('ip'); }, copyText: data.ip }, data.ip)),
                React.createElement(Grid.Column, { width: 16, className: "mb2 py0" },
                    React.createElement("span", { className: "color-charcoal", style: { width: 80, display: 'inline-block' } }, "HTTP Port:"),
                    React.createElement(CopyToClipBoardv2, { onCopy: function () { return onCopied('port'); }, copyText: data.port }, data.port)),
                React.createElement(Grid.Column, { width: 16, className: "mb2 py0" },
                    React.createElement("span", { className: "color-charcoal", style: { width: 80, display: 'inline-block' } }, "Bolt Port:"),
                    React.createElement(CopyToClipBoardv2, { onCopy: function () { return onCopied('boltPort'); }, copyText: data.boltPort }, data.boltPort)))),
        React.createElement("hr", null),
        React.createElement(Grid.Column, { width: 16, className: "mb2 py0" },
            React.createElement("span", { className: "color-charcoal", style: { width: 150, display: 'inline-block' } }, "Bolt URL:"),
            React.createElement("span", null,
                React.createElement(CopyToClipBoardv2, { onCopy: function () { return onCopied('boltUrl'); }, copyText: "bolt://".concat(data.ip, ":").concat(data.boltPort) },
                    "bolt://",
                    data.ip,
                    ":",
                    data.boltPort))),
        React.createElement(Grid.Column, { width: 16, className: "mb2 py0" },
            React.createElement("span", { className: "color-charcoal", style: { width: 150, display: 'inline-block' } }, "Websocket Bolt URL:"),
            React.createElement("span", null,
                React.createElement(CopyToClipBoardv2, { onCopy: function () { return onCopied('websocketBoltUrl'); }, copyText: "bolt+s://".concat(data.sandboxHashKey, ".").concat(constants.SANDBOX_DOMAIN, ":").concat(data.boltPort) },
                    "bolt+s://",
                    data.sandboxHashKey,
                    ".",
                    constants.SANDBOX_DOMAIN,
                    ":",
                    data.boltPort))),
        React.createElement(Grid.Column, { width: 16, className: "mb2 py0" },
            React.createElement("span", { className: "color-charcoal", style: { width: 150, display: 'inline-block' } }, "Websocket Bolt URL (Port 443):"),
            React.createElement("span", null,
                React.createElement(CopyToClipBoardv2, { onCopy: function () { return onCopied('websocketBoltUrl'); }, copyText: "bolt+s://".concat(data.sandboxHashKey, ".").concat(constants.SANDBOX_BOLT_DOMAIN, ":443") },
                    "bolt+s://",
                    data.sandboxHashKey,
                    ".",
                    constants.SANDBOX_BOLT_DOMAIN,
                    ":443")))));
};
export default DatabaseInformation;
